import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Login.css';
import api from "@api";
import { GoogleLogin } from "@react-oauth/google";
import { Helmet } from "react-helmet-async";
function Login() {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [localLoading, setLocalLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showResend, setShowResend] = useState(false);

  const [resendMessage, setResendMessage] = useState("");
  const location = useLocation();
  const returnTo = location.state?.returnTo || "/directory";
  const successMessage = location.state?.message;
  const [flashMessage, setFlashMessage] = useState(successMessage);
  const navigate = useNavigate();
  const { login, googleLogin, isAuthenticated, loading, user } = useAuth();


  // ✅ Redirect once authenticated
  useEffect(() => {
    const redirectAfterLogin = async () => {
      if (!isAuthenticated || !location.pathname.endsWith("/login")) {
        return;
      }

      if (user?.role === "super_admin") {
        navigate("/dashboard/admin/organizations", { replace: true });
        return;
      }

      if (user?.organization_id) {
        const isLeagueDashboardPlan =
          user?.plan === "trial" ||
          user?.plan === "league_tools" ||
          user?.plan === "branded_site" ||
          user?.plan === "custom_domain";

        const isListingOnlyPlan =
          user?.plan === "free" ||
          user?.plan === "directory_free" ||
          user?.plan === "listing_plus";

        if (isLeagueDashboardPlan) {
          navigate("/dashboard/seasons", { replace: true });
        } else if (isListingOnlyPlan && user?.directoryLeagueId) {
          navigate(
            `/dashboard/directory/manage/${user.directoryLeagueId}`,
            { replace: true }
          );
        } else {
          navigate("/dashboard/start-page", { replace: true });
        }

        return;
      }

      try {
        const res = await api.get("/api/user-profiles-v2/me", {
          withCredentials: true,
        });

        const profileId = res.data.profile?.id;

        if (profileId) {
          navigate(`/profile/${profileId}`, { replace: true });
        } else {
          navigate("/dashboard/start-page", { replace: true });
        }
      } catch (error) {
        console.error("Failed to check profile after login:", error);
        navigate("/dashboard/start-page", { replace: true });
      }
    };

    redirectAfterLogin();
  }, [isAuthenticated, user, location.pathname, navigate]);


  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLocalLoading(true);
    setErrorMessage("");
    setShowResend(false);
    setResendMessage("");

    const response = await login(formData);

    if (!response.success) {
      setErrorMessage(response.message);

      if (response.message === "Please verify your email before logging in.") {
        setShowResend(true);
      } else {
        setShowResend(false);
      }

      setLocalLoading(false);
      return;
    }



    setLocalLoading(false);
  };


  const handleResend = async () => {
    try {
      const res = await fetch("/api/auth/resend-verification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: formData.username }),
      });

      const data = await res.json();

      setResendMessage(data.message);
      setShowResend(false); // 👈 hide button after click

    } catch (err) {
      setResendMessage("Something went wrong.");
    }
  };

  useEffect(() => {
    if (successMessage) {
      window.history.replaceState({}, document.title);
    }
  }, []);
  if (loading) return <p></p>;

  return (
    <div className="login_container">
      <Helmet>
        <title>Login | SportingHip</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div className="login_form_container">
        <h3 className="login_form_container_title">Login</h3>
        <form onSubmit={handleLogin} className="login_form">
          <label className="login_form_label">
            Username
            <input
              type='text'
              name='username'
              autoComplete='off'
              value={formData.username}
              onChange={handleInput}
              placeholder="👤  Type your username"
            />
          </label>
          <label className="login_form_label">
            Password
            <input
              type='password'
              name='password'
              value={formData.password}
              onChange={handleInput}
              placeholder="🔒  Type your password"
            />
          </label>
          <button className="login_form_btn" type='submit' disabled={localLoading}>
            {localLoading ? "Logging in..." : "LOGIN"}
          </button>

          <div style={{ marginTop: "1rem", display: "flex", justifyContent: "center" }}>
            <GoogleLogin
              onSuccess={async (credentialResponse) => {
                setLocalLoading(true);
                setErrorMessage("");
                setShowResend(false);
                setResendMessage("");

                const response = await googleLogin(credentialResponse.credential);

                if (!response.success) {
                  setErrorMessage(response.message);
                }

                setLocalLoading(false);
              }}
              onError={() => {
                setErrorMessage("Google sign-in failed.");
              }}
            />
          </div>




          <div style={{ marginTop: "1.5rem" }}>
            <span>Don’t have an account? </span>
            <button
              type="button"
              className="login_form_register_btn"
              onClick={() => navigate("/register")}
            >
              Create an account
            </button>
            <div style={{ marginTop: "10px" }}>
              <a href="/forgot-password" style={{ fontSize: "14px" }}>
                Forgot password?
              </a>
            </div>
          </div>

        </form>
        {flashMessage && !errorMessage && (
          <p style={{ color: "green", marginBottom: "1rem" }}>
            {successMessage}
          </p>
        )}
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        {showResend && (
          <div style={{ marginTop: "10px" }}>
            <button
              type="button"
              onClick={handleResend}
              style={{ fontSize: "14px" }}
            >
              Resend verification email
            </button>

            {resendMessage && (
              <p style={{ color: "green", marginTop: "5px" }}>
                {resendMessage}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
